import { getApiEndpoint } from '../config/api.js';
import type { IntelligenceMetricsSnapshot } from '../features/intelligence/data.js';

export async function fetchIntelligenceMetrics(): Promise<IntelligenceMetricsSnapshot> {
  const response = await fetch(`${getApiEndpoint()}/intelligence/metrics`);
  if (!response.ok) {
    throw new Error(`fetchIntelligenceMetrics failed: ${response.status}`);
  }
  const json = (await response.json()) as IntelligenceMetricsSnapshot;
  if (!json || typeof json !== 'object') {
    throw new Error('fetchIntelligenceMetrics returned invalid payload');
  }
  return json;
}
